import React, { Component } from "react";

interface Props {
	primaryActionLabel: string;
	secondaryActionLabel?: string;
	onPrimaryAction: () => void;
	onSecondaryAction?: () => void;
	disablePrimaryAction?: boolean;
	groupClassName?: string;
	actionContainerClassName?: string;
	primaryActionClassName?: string;
}

interface State {

}

class FormAction extends Component<Props, State> {
	static defaultProps: Partial<Props> = {
		groupClassName: "form-group",
		actionContainerClassName: "col-md-12 mt-3",
		primaryActionClassName: "btn btn_1 btn_style1"
	};

	render() {
		const {
			primaryActionLabel, onPrimaryAction, disablePrimaryAction,
			secondaryActionLabel, onSecondaryAction, groupClassName, actionContainerClassName, primaryActionClassName
		} = this.props;
		return (
			<div className={ actionContainerClassName }>
				<div className={ groupClassName }>
					{ secondaryActionLabel &&
						<a
							href="#"
							onClick={ e => {
								e.preventDefault();
								if ( onSecondaryAction ) onSecondaryAction();
							} }
							className="btn btn-grey btn_style1 me-2">{ secondaryActionLabel }</a>
					}
					<button
						disabled={ disablePrimaryAction }
						className={ primaryActionClassName } onClick={ onPrimaryAction }>
						{ primaryActionLabel }
					</button>

				</div>
			</div>
		);
	}
}

export default FormAction;
